export interface DropdownItemModel {
  Id: number;
  Omschrijving: string;
  GroupId?: string;
}

export interface DropdownItemStringViewModel {
  Id: string;
  Omschrijving: string;
  GroupId?: string;
}

export enum FixedPeriodType {
  FreePeriod = 1,
  Today = 2,
  Yesterday = 3,
  ThisWeek = 4,
  LastWeek = 5,
  ThisMonth = 6,
  LastMonth = 7,
  ThisQuarter = 8,
  LastQuarter = 9,
  ThisYear = 10,
  LastYear = 11
}

export interface FilterValuesPeriod {
  Id: FixedPeriodType;
  Omschrijving: string;
}

export interface AutobedrijfViewModel {
  Id: string;
  Omschrijving: string;
  ZoneId: number | null;
}

export interface VestigingViewModel {
  Id: string;
  Omschrijving: string;
  AutobedrijfId: string;
  ZoneId: number | null;
}

export interface LookupItemViewModel {
  LookupID: string;
  LookupValue: string;
}